module.exports = __webpack_public_path__ + "static/media/more_vertical_black.b3f958a5.svg";